import React, { useState } from "react";
import toast from "react-hot-toast";
import DeliveryPartnerDropdown from "../Dropdowns/DeliveryPartnerDropdown";

const CreateDeliveryRequestModal = ({
  show,
  onClose,
  onSave,
  limit,
  page,
  setPage,
  handleFee,
  calculating,
  saving,
}) => {
  const [formData, setFormData] = useState({
    partner_id: "",
    total_value: "",
    customer_name: "",
    customer_email: "",
    customer_phone: "",
    customer_address: "",
    sender_name: "",
    sender_email: "",
    sender_phone: "",
    store_address: "",
    delivery_fee: "",
    delivery_distance: "",
    unit: "",
    fulfillment_type: "delivery",
  });

  const [errors, setErrors] = useState({});

  const handlePartnerSelect = (partner) => {
    setFormData((prev) => ({
      ...prev,
      partner_id: partner.id,
    }));
    setErrors((prev) => ({ ...prev, partner_id: "" }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    let errorMsg = "";

    if (["customer_email", "sender_email"].includes(name)) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (value.trim() && !emailRegex.test(value.trim())) {
        errorMsg = "Enter a valid email";
      }
    }

    setErrors((prev) => ({
      ...prev,
      [name]: errorMsg,
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.partner_id) newErrors.partner_id = "Please select a partner";
    if (!formData.total_value)
      newErrors.total_value = "Total value is required";
    if (!formData.customer_name)
      newErrors.customer_name = "Customer name is required";
    if (!formData.sender_name)
      newErrors.sender_name = "Sender name is required";

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    ["customer_email", "sender_email"].forEach((field) => {
      const label = field === "customer_email" ? "Customer" : "Sender";
      const email = formData[field]?.trim();

      if (!email) {
        newErrors[field] = `${label} email is required`;
      } else if (!emailRegex.test(email)) {
        newErrors[field] = `Enter a valid email`;
      }
    });

    //Phone validation
    ["customer_phone", "sender_phone"].forEach((field) => {
      if (
        !formData[field] ||
        formData[field] === "+251" ||
        formData[field].length <= 4
      ) {
        newErrors[field] = `${
          field === "customer_phone" ? "Customer" : "Sender"
        } phone is required`;
      }
    });

    if (!formData.customer_address)
      newErrors.customer_address = "Customer address is required";
    if (!formData.store_address)
      newErrors.store_address = "Sender address is required";
    if (!formData.delivery_fee)
      newErrors.delivery_fee = "Please calculate delivery fee first";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error("Please fill all required fields");
      return;
    }

    const trimmedData = Object.fromEntries(
      Object.entries(formData).map(([key, value]) => [
        key,
        typeof value === "string" ? value.trim() : value,
      ])
    );

    const resetForm = () => {
      setFormData({
        partner_id: "",
        total_value: "",
        customer_name: "",
        customer_email: "",
        customer_phone: "",
        customer_address: "",
        sender_name: "",
        sender_email: "",
        sender_phone: "",
        store_address: "",
        delivery_fee: "",
        delivery_distance: "",
        unit: "",
        fulfillment_type: "delivery",
      });
      setErrors({});
    };

    onSave(trimmedData, resetForm);
  };

  return (
    <>
      {show && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)",
            paddingTop: "80px",
          }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              {/* Header */}
              <div className="modal-header">
                <h5 className="modal-title">Add New Request</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={onClose}
                ></button>
              </div>

              {/* Body */}
              <div
                className="modal-body"
                style={{ maxHeight: "70vh", overflowY: "auto" }}
              >
                <form>
                  {/* Partner + Total Value */}
                  <div className="row col-xl-12">
                    <div className="mb-3 col-xl-6">
                      <label className="form-label">Partner</label>
                      <DeliveryPartnerDropdown
                        onSelect={handlePartnerSelect}
                        limit={limit}
                        page={page}
                        setPage={setPage}
                      />
                      {errors.partner_id && (
                        <div className="small" style={{ color: "red" }}>
                          {errors.partner_id}
                        </div>
                      )}
                    </div>

                    <div className="mb-3 col-xl-6">
                      <label className="form-label">Total Value</label>
                      <input
                        type="number"
                        name="total_value"
                        className="form-control"
                        value={formData.total_value}
                        onChange={handleChange}
                      />
                      {errors.total_value && (
                        <div className=" small" style={{ color: "red" }}>
                          {errors.total_value}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="row col-xl-12">
                    <div className="mb-3 col-xl-4">
                      <label className="form-label">Sender Name</label>
                      <input
                        type="text"
                        name="sender_name"
                        className="form-control"
                        value={formData.sender_name}
                        onChange={handleChange}
                      />
                      {errors.sender_name && (
                        <div className="small" style={{ color: "red" }}>
                          {errors.sender_name}
                        </div>
                      )}
                    </div>

                    <div className="mb-3 col-xl-4">
                      <label className="form-label">Sender Email</label>
                      <input
                        type="email"
                        name="sender_email"
                        className="form-control"
                        value={formData.sender_email}
                        onChange={handleChange}
                      />
                      {errors.sender_email && (
                        <div className=" small" style={{ color: "red" }}>
                          {errors.sender_email}
                        </div>
                      )}
                    </div>

                    <div className="mb-3 col-xl-4 text-start">
                      <label className="form-label"> Sender Phone</label>

                      <div style={{ position: "relative", width: "100%" }}>
                        <img
                          src="https://flagcdn.com/et.svg"
                          alt="Ethiopia"
                          style={{
                            width: "24px",
                            height: "16px",
                            position: "absolute",
                            left: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                          }}
                        />

                        <span
                          style={{
                            position: "absolute",
                            left: "40px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            fontSize: "1rem",
                            color: "black",
                            userSelect: "none",
                          }}
                        >
                          +251
                        </span>

                        <input
                          type="tel"
                          maxLength={9}
                          value={formData.sender_phone.replace("+251", "")}
                          className={`form-control ${
                            errors.sender_phone ? "is-invalid" : ""
                          }`}
                          onChange={(e) => {
                            const raw = e.target.value.replace(/\D/g, "");
                            setFormData((prev) => ({
                              ...prev,
                              sender_phone: `+251${raw}`,
                            }));
                            setErrors((prev) => ({
                              ...prev,
                              sender_phone: "",
                            }));
                          }}
                          placeholder="911 234 567"
                          style={{
                            width: "100%",
                            height: "40px",
                            paddingLeft: "90px",
                            fontSize: "1rem",
                            border: "2px solid #3f5263",
                            borderRadius: "0.375rem",
                            outline: "none",
                          }}
                        />
                      </div>

                      {errors.sender_phone && (
                        <div
                          className="invalid-feedback d-block mt-1"
                          style={{ color: "red" }}
                        >
                          {errors.sender_phone}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Customer Info */}
                  <div className="row col-xl-12">
                    <div className="mb-3 col-xl-4">
                      <label className="form-label">Customer Name</label>
                      <input
                        type="text"
                        name="customer_name"
                        className="form-control"
                        value={formData.customer_name}
                        onChange={handleChange}
                      />
                      {errors.customer_name && (
                        <div className="small" style={{ color: "red" }}>
                          {errors.customer_name}
                        </div>
                      )}
                    </div>

                    <div className="mb-3 col-xl-4">
                      <label className="form-label">Customer Email</label>
                      <input
                        type="email"
                        name="customer_email"
                        className="form-control"
                        value={formData.customer_email}
                        onChange={handleChange}
                      />
                      {errors.customer_email && (
                        <div className=" small" style={{ color: "red" }}>
                          {errors.customer_email}
                        </div>
                      )}
                    </div>

                    <div className="mb-3 col-xl-4 text-start">
                      <label className="form-label"> Customer Phone</label>

                      <div style={{ position: "relative", width: "100%" }}>
                        <img
                          src="https://flagcdn.com/et.svg"
                          alt="Ethiopia"
                          style={{
                            width: "24px",
                            height: "16px",
                            position: "absolute",
                            left: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                          }}
                        />

                        <span
                          style={{
                            position: "absolute",
                            left: "40px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            fontSize: "1rem",
                            color: "black",
                            userSelect: "none",
                          }}
                        >
                          +251
                        </span>

                        <input
                          type="tel"
                          maxLength={9}
                          value={formData.customer_phone.replace("+251", "")}
                          className={`form-control ${
                            errors.customer_phone ? "is-invalid" : ""
                          }`}
                          onChange={(e) => {
                            const raw = e.target.value.replace(/\D/g, "");
                            setFormData((prev) => ({
                              ...prev,
                              customer_phone: `+251${raw}`,
                            }));
                            setErrors((prev) => ({
                              ...prev,
                              customer_phone: "",
                            }));
                          }}
                          placeholder="911 234 567"
                          style={{
                            width: "100%",
                            height: "40px",
                            paddingLeft: "90px",
                            fontSize: "1rem",
                            border: "2px solid #3f5263",
                            borderRadius: "0.375rem",
                            outline: "none",
                          }}
                        />
                      </div>

                      {errors.customer_phone && (
                        <div
                          className="invalid-feedback d-block mt-1"
                          style={{ color: "red" }}
                        >
                          {errors.customer_phone}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Addresses */}
                  <div className="row mb-2 col-xl-12">
                    <div className=" col-xl-6">
                      <label className="form-label">Customer Address</label>
                      <input
                        type="text"
                        name="customer_address"
                        className="form-control"
                        value={formData.customer_address}
                        onChange={handleChange}
                      />
                      {errors.customer_address && (
                        <div className="small" style={{ color: "red" }}>
                          {errors.customer_address}
                        </div>
                      )}
                    </div>

                    <div className=" col-xl-6">
                      <label className="form-label">Sender Address</label>
                      <input
                        type="text"
                        name="store_address"
                        className="form-control"
                        value={formData.store_address}
                        onChange={handleChange}
                      />
                      {errors.store_address && (
                        <div className="small" style={{ color: "red" }}>
                          {errors.store_address}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Fee Button */}
                  <button
                    className="btn btn-sm btn-danger text-info"
                    onClick={(e) => handleFee(e, formData, setFormData)}
                    disabled={calculating}
                  >
                    {calculating ? "Calculating..." : "Calculate Delivery Fee"}
                  </button>

                  {/* Fee & Distance */}
                  <div className="row col-xl-12 mt-3">
                    <div className="mb-3 col-xl-6">
                      <label className="form-label">Delivery Fee</label>
                      <input
                        type="number"
                        name="delivery_fee"
                        className="form-control"
                        value={formData.delivery_fee}
                        onChange={handleChange}
                        readOnly
                      />
                      {errors.delivery_fee && (
                        <div className="small" style={{ color: "red" }}>
                          {errors.delivery_fee}
                        </div>
                      )}
                    </div>

                    <div className="mb-3 col-xl-6">
                      <label className="form-label">Delivery Distance</label>
                      <div className="input-group">
                        <input
                          type="number"
                          name="delivery_distance"
                          className="form-control"
                          value={formData.delivery_distance}
                          onChange={handleChange}
                          readOnly
                        />
                        <span className="input-group-text">
                          {formData.unit}
                        </span>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              {/* Footer */}
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={onClose}>
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleSave}
                  disabled={saving}
                >
                  {saving ? "Saving..." : "Add Request"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CreateDeliveryRequestModal;
